import React, { useEffect, useState, useMemo } from "react";
import {
  FUNDING_SETUP_LIMIT,
  emptyPaginationObj,
  LOADER_STATUS,
} from "../../../../Constants/constant";
import { getPaginationObj } from "../../../../Utils/utils";
import PaginationComponent from "../../../../components/common/Pagination/index";
import TableHeader from "../../../../components/common/Table/TableHeader";
import CircularLoader from "../../../../components/common/CircularLoader/CircularLoader";
import ConfirmationModal from "../../../../components/common/Modal/ConfirmationModal";
import FundingItem from "./fundingItem";
import { PERMISSION_KEYS, PERMISSION_KEYS_CHILDREN } from "store/constants";
import { roleAccess } from "helpers/RolesPermission";

const FundingSetupTable = (props) => {
  const {
    participantFundings,
    participant,
    isLoading,
    getParticipantFundingsSetup,
    participantOnBoarding,
    setEditFundingData,
    moduleType,
    storeAndUpdateFundingSetupRequest,
    fundingSetupLoading,
    deleteFundingSetupRequest,
    deleteFundingLoading,
  } = props;
  const [renderLoading, setRenderLoading] = useState(LOADER_STATUS.NA);

  const [paginationObj, setPaginationObj] = useState(
    participantFundings
      ? getPaginationObj(participantFundings)
      : emptyPaginationObj
  );
  const [fundingToDelete, setFundingToDelete] = useState(null);

  useEffect(() => {
    if (!isLoading && renderLoading === LOADER_STATUS.PENDING) {
      setRenderLoading(LOADER_STATUS.COMPLATE);
    }
  }, [isLoading]);

  useEffect(() => {
    if (participantFundings) {
      setPaginationObj({
        ...getPaginationObj(participantFundings),
      });
    }
  }, [participantFundings]);

  const fundingToMap = useMemo(() => {
    if (participantFundings && participantFundings.data) {
      return participantFundings.data;
    }
    return [];
  }, [participantFundings]);

  useEffect(() => {
    setRenderLoading(LOADER_STATUS.PENDING);
    if (participantFundings) {
      setPaginationObj(getPaginationObj(participantFundings));
    }
    if (!participantFundings) fetchFundingSetups({ page: 1 });
  }, []);

  useEffect(() => {
    if (
      participantFundings &&
      participantFundings.current_page !== paginationObj.page
    ) {
      fetchFundingSetups({ page: paginationObj.page });
    }
  }, [paginationObj.page]);

  const fetchFundingSetups = async (filters) => {
    if (!filters || filters === undefined) {
      Object.assign((filters = {}), {
        page: paginationObj.page,
      });
    }
    Object.assign(filters, { per_page: FUNDING_SETUP_LIMIT });
    Object.assign(filters, { pt_id: participant.uuid || 1 });
    if (renderLoading === LOADER_STATUS.NA) {
      setRenderLoading(LOADER_STATUS.PENDING);
    }
    getParticipantFundingsSetup(filters);
  };

  const confirmDeleteFunding = () => {
    if (!fundingToDelete || !deleteFundingSetupRequest) return;
    deleteFundingSetupRequest({
      id: fundingToDelete.uuid,
      pt_id: participant.uuid,
      page: paginationObj.page,
      per_page: FUNDING_SETUP_LIMIT,
    });
    setFundingToDelete(null);
  };

  return (
    <div className='px-4 sm:px-6 py-4 sm:py-6'>
      <div className='flex flex-col'>

        <div className='bg-white border border-gray-200 rounded-xl shadow-lg overflow-hidden'>
          <div className='overflow-x-auto custom-scroll'>
            <div className='inline-block min-w-full align-middle'>
              <div className='overflow-hidden'>
                <table className='min-w-full divide-y divide-gray-300'>
                  <thead className='bg-blue-50 capitalize'>
                    <tr>
                    <TableHeader isSort={false} label={"Funding Id"} />
                    <TableHeader
                      isSort={false}
                      label={"Start Date"}
                      cssClass='px-0'
                    />
                    <TableHeader isSort={false} label={"End Date"} />
                    <TableHeader
                      isSort={false}
                      label={"Total Funding"}
                      cssClass='px-0'
                    />
                    <TableHeader
                      isSort={false}
                      label={"Total Allocated"}
                      cssClass='px-0'
                    />
                    <TableHeader
                      isSort={false}
                      label={"Total Delivered"}
                      cssClass='px-0'
                    />
                    {/* <TableHeader 
                      isSort={false}
                      sortName="claimed"
                      //   flipSort={flipSort}
                      //   sortBy={sortBy}
                      //   sortDescending={sortDescending}
                      label={"Claimed"}
                      cssClass="px-0"

                    />
                    <TableHeader 
                      isSort={false}
                      sortName="Unclaimed"
                      //   flipSort={flipSort}
                      //   sortBy={sortBy}
                      //   sortDescending={sortDescending}
                      label={"Unclaimed"}
                      cssClass="px-0"

                    /> */}
                    <TableHeader
                      isSort={false}
                      label={"Unallocated"}
                      cssClass='px-0'
                    />
                    <TableHeader
                      isSort={false}
                      label={"Status"}
                      cssClass='px-0'
                    />
                    {roleAccess(
                      [],
                      PERMISSION_KEYS.PARTICIPANT,
                      PERMISSION_KEYS_CHILDREN.PARTICIPANT.FUNDING.UPDATE
                    ) && (
                      <TableHeader
                        isSort={false}
                        label={"Actions"}
                        cssClass='px-0'
                      />
                    )}
                  </tr>
                </thead>
                <tbody className='divide-y divide-gray-200 bg-white'>
                  {isLoading ? (
                    <tr>
                      <td colSpan={11} className='bg-white py-12'>
                        <div className='flex justify-center items-center'>
                          <CircularLoader
                            classes='flex justify-center items-center'
                            classloader='loader-l'
                          />
                        </div>
                      </td>
                    </tr>
                  ) : fundingToMap.length > 0 ? (
                    fundingToMap.map((fund, index) => (
                      <FundingItem
                        key={index}
                        fund={fund}
                        index={index}
                        participant={participant}
                        participantOnBoarding={participantOnBoarding}
                        setEditFundingData={setEditFundingData}
                        moduleType={moduleType}
                        storeAndUpdateFundingSetupRequest={
                          storeAndUpdateFundingSetupRequest
                        }
                        fundingSetupLoading={fundingSetupLoading}
                        onDeleteFunding={(fund) => setFundingToDelete(fund)}
                      />
                    ))
                  ) : (
                    renderLoading !== LOADER_STATUS.NA &&
                    fundingToMap.length === 0 && (
                      <tr>
                        <td
                          colSpan={11}
                          className='py-12 text-center bg-white'
                        >
                          <div className='flex flex-col items-center justify-center'>
                            <div className='w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center mb-4'>
                              <svg className='w-8 h-8 text-gray-400' fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                              </svg>
                            </div>
                            <p className='font-medium text-gray-500'>No funding data found!</p>
                            <p className='text-sm text-gray-400 mt-1'>Add funding setup to get started</p>
                          </div>
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {fundingToDelete && (
        <ConfirmationModal
          isNew
          showModal={!!fundingToDelete}
          title='Remove funding?'
          heading={
            <>
              <span className='block font-semibold text-gray-900 mb-2'>
                Are you sure you want to delete this Funding{" "}
                {fundingToDelete.contract_id}?
              </span>
              <span className='block text-sm text-gray-600 leading-relaxed'>
                Deletion of funding will also delete all case notes data and all created
                invoices and NDIS claims associated with this funding. This action is
                irreversible.
              </span>
            </>
          }
          confirmBtnLabel='Yes, remove funding'
          cancelBtnLabel='Cancel'
          variantConfirmBtn='danger'
          confirmBtnLoader={deleteFundingLoading}
          submitHandler={confirmDeleteFunding}
          closeModalHandler={() => !deleteFundingLoading && setFundingToDelete(null)}
        />
      )}

      {fundingToMap.length > 0 && (
        <div className='bg-white py-4 mt-4'>
          <PaginationComponent
            page={paginationObj.page}
            activeListLength={fundingToMap}
            limit={FUNDING_SETUP_LIMIT}
            totalList={
              paginationObj.totalPages === 1
                ? fundingToMap.length
                : paginationObj.total
            }
            handlePagination={(e) => {
              const obj = paginationObj;
              obj.page = e;
              setPaginationObj({ ...obj });
              // handleFetch({}, sortBy);
            }}
            totalPages={paginationObj.totalPages}
          />
        </div>
      )}
    </div>
  );
};

export default FundingSetupTable;
